import api from "./api";
import TokenService from "./token.service";

const register = (username, email, password) => {
  return api.post("/signup", {
    username,
    email,
    password
  });
};
const login = (username, password) => {
  return api.post("/login", {
      username,
      password
    })
    .then((response) => {
      if (response.data.token) {
        TokenService.setUser(response.data);
        return response.data;

      }else{
        return response.data.password;
      }
     
    });
};
const logout = () => {
  // Delete Request an refresh-token schicken
  return api.delete("/refresh-token")
  .then(() => {
    TokenService.removeUser();
  });
};
const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
};
export default AuthService;